import services from "../services";
import * as types from "./mutation-type";

export const ActionCreateRating = ({_}, payload) => {
    return new Promise(async (resolve, reject) => {
      try {
          const { data } = await services.create(payload)
          if(!data?.error) {
              resolve(data)
          }
          reject(data)
      } catch(error) {
          reject(error.response.data)
      }
    })
}

export const getListByProductId = ({_}, {payload, id}) => {
  return new Promise(async (resolve, reject) => {
    try {
        const { data } = await services.getListByProductId(payload, id)
        if(!data?.error) {
            resolve(data)
        }
        reject(data)
    } catch(error) {
        reject(error.response.data)
    }
  })
}